import React, { memo } from "react";
import { array, string, func, object } from "prop-types";

import style from "./style.module.scss";
import { USER_ROLE_LABELS } from "helpers/constants";
import CompareStatus from "./CompareStatus";
import {
  COMPARED_STATUS,
  formatDate,
  formatPercent,
  getComparisons,
  getLevel,
  getUserName,
  isComparisonReady,
} from "./utils";

export default memo(HistoryTimeline);

HistoryTimeline.propTypes = {
  histories: array,
  selectedHistoryId: string,
  onSelect: func,
};

function HistoryTimeline({ histories, selectedHistoryId, onSelect }) {
  return (
    <div className={style.timeline}>
      {histories.map((history, idx) => {
        const isActive = selectedHistoryId === history.historyId;
        const role = USER_ROLE_LABELS[history.roleCode] || "-";
        const fullName = getUserName(history);

        return (
          <button
            type="button"
            key={history.historyId || idx}
            className={`${style.timelineCard} ${
              isActive ? style.timelineCardActive : ""
            }`}
            onClick={() => onSelect(history.historyId)}
            title={`${fullName} | ${role} | ${history.sourceStatus || "-"}`}
          >
            <div className={style.timelineRow}>
              <span className={style.timelineUser}>
                {fullName}
                <span className={style.timelineRole}> · {role}</span>
              </span>
              <HistoryBadge history={history} />
            </div>
            <div className={style.timelineStatus}>
              {history.previousSourceStatus || "-"} →{" "}
              <b>{history.sourceStatus || "-"}</b>
            </div>
            <div className={style.timelineTime}>
              {formatDate(history.createdDate)}
            </div>
          </button>
        );
      })}
    </div>
  );
}

HistoryBadge.propTypes = {
  history: object,
};

function HistoryBadge({ history }) {
  if (history.isGroundTruth) {
    return (
      <span className={`${style.badge} ${style.badgeGroundTruth}`}>⭐</span>
    );
  }

  const comparisons = getComparisons(history);
  if (!comparisons.length) return null;

  return (
    <span className={style.badgeGroup}>
      {comparisons.map((comparison) => {
        const match = comparison.result?.overall?.matchPercentage;
        const isReady = isComparisonReady(comparison);
        const levelClass = isReady
          ? style[`level_${getLevel(match)}`]
          : comparison.status === COMPARED_STATUS.FAILED
          ? style.level_bad
          : style.badgeMuted;

        return (
          <span
            key={comparison.key}
            className={`${style.badge} ${levelClass}`}
            title={`So với ${comparison.title}`}
          >
            {comparison.short}{" "}
            {isReady ? (
              formatPercent(match)
            ) : (
              <CompareStatus status={comparison.status} compact />
            )}
          </span>
        );
      })}
    </span>
  );
}
